enum MasterPremission {
  Prem_Master_Items_Report_Zip = 'Prem_Master_Items_Report_Zip',
  Prem_Master_Documantation = 'Prem_Master_Documantation',
  Prem_Activity_Log = 'Prem_Activity_Log',
}

export default MasterPremission;
